/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var FlaggedStatusIcon = createIcon("FlaggedStatusIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M.969 1.906h13.594a.468.468 0 01.35.78L12.409 5.5a.938.938 0 000 1.246l2.5 2.816a.47.47 0 01-.35.78H.97",
    fill: "#DE3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.969 1.906h13.594a.468.468 0 01.35.78L12.409 5.5a.938.938 0 000 1.246l2.5 2.816a.47.47 0 01-.35.78H.97",
    stroke: "#DE3333",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.969.969V15.03.97Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.969.969V15.03",
    stroke: "#0C0D0D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {});